import VersionLog from './VersionLog';

export default VersionLog;
